export default __webpack_public_path__ + "4ca985980b.svg";